import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InteractivePillComponent } from '../../../pills/interactive-pill/interactive-pill.component';
import { ButtonComponent } from '../../../buttons/button/button.component';
import { TableFilter, TableFilterOption } from '../../models/table-filter';
import { ButtonType } from '../../../enum/button-type.enum';
import { InputSize } from '../../../enum/input-size.enum';

@Component({
  selector: 'lib-pill-selection-filter',
  imports: [ButtonComponent, InteractivePillComponent],
  templateUrl: './pill-selection-filter.component.html',
  styleUrl: './pill-selection-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillSelectionFilterComponent {
  tableFilter = input.required<TableFilter>();

  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;

  pillOptionsClicked(option: TableFilterOption) {
    option.isSelected?.update(value => !value);
  }

  resetClicked() {
    this.tableFilter().resetUnsavedOptions();
  }
}
